import { Chart } from '@threatadvisor/react-components';
import { formatDateTimeChart } from '@threatadvisor/react-utils';
import { Descriptions } from 'antd';
import React, { ReactElement } from 'react';
import {
  getAvgTimeToAction,
  getAvgTimeToStartTriage,
  getSecEventVolumeByDay,
  getSecEventVolumeByStatusTotal,
  getSecEventVolumeTotal
} from './CubeJSQueries';

type EventStatisticsProps = {
  clientUid: string;
  reportStart: string;
  reportEnd: string;
};

export default function EventStatistics(props: EventStatisticsProps): ReactElement {
  const { clientUid, reportStart, reportEnd } = props;

  const totalVolumeQuery = getSecEventVolumeTotal(reportStart, reportEnd, clientUid);
  const totalClearedQuery = getSecEventVolumeByStatusTotal(
    reportStart,
    reportEnd,
    clientUid,
    'Cleared'
  );
  const totalLinkedQuery = getSecEventVolumeByStatusTotal(
    reportStart,
    reportEnd,
    clientUid,
    'Linked'
  );
  const avgDailyVolumeQuery = getSecEventVolumeByDay(reportStart, reportEnd, clientUid);

  const avgTriageQuery = getAvgTimeToStartTriage(reportStart, reportEnd, clientUid);
  const avgActionQuery = getAvgTimeToAction(reportStart, reportEnd, clientUid);

  return (
    <>
      <h2 className="text-uppercase">Event Statistics</h2>
      <Descriptions column={6}>
        <Descriptions.Item label="Number of Events Received" span={3}>
          <Chart config={totalVolumeQuery} />
        </Descriptions.Item>
        <Descriptions.Item label="Number of Events Cleared" span={3}>
          <Chart config={totalClearedQuery} />
        </Descriptions.Item>
        <Descriptions.Item label="Number of Events Promoted To Investigation" span={3}>
          <Chart config={totalLinkedQuery} />
        </Descriptions.Item>
        <Descriptions.Item label="Average Daily Volume" span={3}>
          <Chart config={avgDailyVolumeQuery} chartConfig={{ aggregate: 'meanBy' }} />
        </Descriptions.Item>
        <Descriptions.Item label="Average Time to Start Triage" span={3}>
          <Chart
            config={avgTriageQuery}
            chartConfig={{
              labelFormatter: val => (val < 1 ? '< 1 min' : formatDateTimeChart(val, false))
            }}
          />
        </Descriptions.Item>
        <Descriptions.Item label="Average Time to Action" span={3}>
          <Chart
            config={avgActionQuery}
            chartConfig={{
              labelFormatter: val => (val < 1 ? '< 1 min' : formatDateTimeChart(val, false))
            }}
          />
        </Descriptions.Item>
      </Descriptions>
    </>
  );
}
